// extracted by mini-css-extract-plugin
export default {"iconWrap":"Breadcrumbs-module__iconWrap__LhDGA","container":"Breadcrumbs-module__container__F8vQ5"};